import { render, staticRenderFns } from "./Support3.vue?vue&type=template&id=318cb9b8&scoped=true"
import script from "./Support3.vue?vue&type=script&lang=js"
export * from "./Support3.vue?vue&type=script&lang=js"
import style0 from "./Support3.vue?vue&type=style&index=0&id=318cb9b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318cb9b8",
  null
  
)

export default component.exports